import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text, Heading } from 'components/chroma';

export const DifferenceModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal
    header="What is the difference between secured and unsecured loans?"
    isOpen={isOpen}
    onClose={onClose}
  >
    <Heading size={2} margin={{ bottom: 1 }}>
      Secured Loan
    </Heading>
    <Text>
      The car is used as security against the loan. The lender can sell the car
      to pay off a loan if you fail to make your repayments.
    </Text>
    <Heading size={2} margin={{ bottom: 1 }}>
      Unsecured Loan
    </Heading>
    <Text>
      The car has not been used as security against the loan and the lender
      cannot take possession of the car if the loan repayments are not met.
    </Text>
  </Modal>
);

export default DifferenceModal;
